"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var ActiveIntegration = function ActiveIntegration(_ref) {
  var name = _ref.name,
      email = _ref.email,
      useEmailIntegration = _ref.useEmailIntegration,
      useCalendarIntegration = _ref.useCalendarIntegration,
      usingDkim = _ref.usingDkim,
      isLoading = _ref.isLoading,
      onDisconnect = _ref.onDisconnect,
      onUpdateEmail = _ref.onUpdateEmail,
      onUpdateCalendar = _ref.onUpdateCalendar;
  var handleSetEmail = (0, _react.useCallback)(function (value) {
    return onUpdateEmail(value);
  }, [onUpdateEmail]);
  var handleSetCalendar = (0, _react.useCallback)(function (value) {
    return onUpdateCalendar(value);
  }, [onUpdateCalendar]);
  var isCalendarAvailable = useCalendarIntegration.available;
  var isCalendarEnabled = useCalendarIntegration.enabled;
  var isEmailAvailable = useEmailIntegration.available;
  var isEmailEnabled = useEmailIntegration.enabled;
  var isEmailBlocked = isLoading || !isEmailAvailable || usingDkim;
  var serviceScope = usingDkim ? 'calendar' : 'account';
  var isCancelButtonVisible = !usingDkim || usingDkim && isCalendarEnabled;
  var serviceStatus = isCancelButtonVisible ? 'is integrated' : 'is not integrated';
  return /*#__PURE__*/_react.default.createElement(_material.Paper, {
    elevation: 1,
    "data-testid": "ActiveIntegration"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    p: 2,
    m: 2,
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('H4-Dark-Bold')
  }, "Your ", name, " ", serviceScope, " ", serviceStatus, "!")), /*#__PURE__*/_react.default.createElement(_ui.LoadingWrapper, {
    isLoading: isLoading,
    mt: "6px",
    width: 350
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, usingDkim ? "Alyce will automatically add meetings on your ".concat(name, " calendar any time a prospect accepts your terms!") : "Alyce will now use your email to send your initial gift invite to your recipients and will automatically add meetings on your ".concat(name, " calendar any time a recipient accepts your terms!"))), /*#__PURE__*/_react.default.createElement(_ui.LoadingWrapper, {
    isLoading: isLoading,
    mt: "6px",
    width: 150
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "Linked to: ", /*#__PURE__*/_react.default.createElement("strong", null, email)))), !usingDkim && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1,
    ml: 3
  }, /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    disabled: isEmailBlocked,
    "data-testid": "ActiveIntegration.Email.FormControlLabel",
    control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
      checked: isEmailEnabled,
      onChange: function onChange(event, value) {
        return handleSetEmail(value);
      },
      value: isEmailEnabled,
      color: "primary"
    }),
    label: "Send emails via your ".concat(name, " account")
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 3
  }, /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    disabled: isLoading || !isCalendarAvailable,
    "data-testid": "ActiveIntegration.Calendar.FormControlLabel",
    control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
      checked: isCalendarEnabled,
      onChange: function onChange(event, value) {
        return handleSetCalendar(value);
      },
      value: isCalendarEnabled,
      color: "primary"
    }),
    label: "Book meetings via your ".concat(name, " account")
  }))), usingDkim && isCalendarEnabled && /*#__PURE__*/_react.default.createElement(_ui.LoadingWrapper, {
    isLoading: isLoading,
    mt: "6px",
    width: 350
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2,
    ml: 2,
    display: "flex",
    alignItems: "center",
    justtifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "inline-block",
    mr: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "check",
    color: "green.main"
  })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "Book meetings via your ", name, " account"))), usingDkim && !isCalendarEnabled && /*#__PURE__*/_react.default.createElement(_ui.LoadingWrapper, {
    isLoading: isLoading,
    mt: "6px",
    width: 350
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2,
    ml: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "inline-block",
    mr: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "times",
    color: "error.main"
  })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "You cannot book meetings via your ", name, " account"))), usingDkim && /*#__PURE__*/_react.default.createElement(_ui.LoadingWrapper, {
    isLoading: isLoading,
    mt: "6px",
    width: 350
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    my: 3
  }, /*#__PURE__*/_react.default.createElement(_ui.HtmlTip, null, "Your organization admin has set up Domain Authentication for your org emails. The email integration is unavailable and the initial email will be sent from your address using Domain Authentication."))), usingDkim && !isCalendarEnabled && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.ActionButton, {
    width: 275,
    disabled: isLoading,
    "data-testid": "ActiveIntegration.Connect.Calendar.Button",
    onClick: function onClick() {
      return handleSetCalendar(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "inline-block",
    mr: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "plus-circle",
    size: "sm",
    color: "common.white"
  })), "Connect your ", name, " calendar")), isCancelButtonVisible && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.CancelButton, {
    width: 275,
    disabled: isLoading,
    "data-testid": "ActiveIntegration.Cancel.Button",
    onClick: onDisconnect
  }, "Disconnect my ", name, " account"))));
};

ActiveIntegration.propTypes = {
  name: _propTypes.default.string.isRequired,
  email: _propTypes.default.string.isRequired,
  useEmailIntegration: _propTypes.default.shape({
    available: _propTypes.default.bool,
    enabled: _propTypes.default.bool
  }).isRequired,
  useCalendarIntegration: _propTypes.default.shape({
    available: _propTypes.default.bool,
    enabled: _propTypes.default.bool
  }).isRequired,
  usingDkim: _propTypes.default.bool.isRequired,
  isLoading: _propTypes.default.bool.isRequired,
  onDisconnect: _propTypes.default.func.isRequired,
  onUpdateEmail: _propTypes.default.func.isRequired,
  onUpdateCalendar: _propTypes.default.func.isRequired
};
var _default = ActiveIntegration;
exports.default = _default;